"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.directMessages.loadFailed': 'No se pudieron cargar los mensajes directos.',
    'whatsapp.directMessages.search': 'Buscar contactos...',
    'whatsapp.directMessages.contacts': 'Contactos',
    'whatsapp.directMessages.noContacts': 'No se encontraron contactos de mensajes directos.',
    'whatsapp.directMessages.trackLogs': 'Registros de seguimiento',
    'whatsapp.directMessages.selectContact': 'Seleccione un contacto para ver los registros de seguimiento.',
    'whatsapp.directMessages.noLogs': 'No hay registros de seguimiento para este contacto.',
    'whatsapp.directMessages.viewDetails': 'Ver detalles',
};
